import React,{useState}  from "react";
import Slider from "../components/Slider";
import '../PageCss/Home.css'
import { useAappContext } from "../context/AppContext";
import ProductS from "../components/ProductS";
import '../PageCss/ControlPage.css'



     

const Home = () =>{
const{ products} = useAappContext();


const [currentPage, setCurrentPage] = useState(1);
const productsPerPage =12;

const indexOfLastProduct = currentPage * productsPerPage;
const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);
const totalPages = Math.ceil(products.length / productsPerPage);



return (
    <>
      <Slider />
      <section id="productsSection" className="section-p1 section-m1">
        <div id='page-title' className="title-red">
          <span>Typical products</span>
        </div>
        <br />
        <div className="container">
          <div className="productContaner" style={{ margin: 0 }}>
            {currentProducts.map((curElem) => (
              <ProductS key={curElem.id} {...curElem} />
            ))}
          </div>
        </div>

        {/* Pagination Controls */}
        <div className="pagination-controls">
          <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
            Prev
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentPage(index + 1)}
              className={currentPage === index + 1 ? 'active' : ''}
            >
              {index + 1}
            </button>
          ))}
          <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
      </section>
    </>
  );
};

export default Home;